import * as Yup from "yup";

export const useItemsSchema = ({
  translate,
  requireTax = false,
  isPOorDN = false,
}: {
  translate: (k: string, options?: any) => string;
  requireTax?: boolean;
  isPOorDN?: boolean;
}) => {
  const itemsSchema = Yup.object().shape({
    referenceCode: Yup.string()
      .required(translate("referenceCode_is_required"))
      .max(
        100,
        translate("field_name_cannot_exceed_characters", {
          fieldName: translate("referenceCode"),
          number: 100,
        }),
      ),
    description: Yup.string()
      .required(translate("description_is_required"))
      .max(
        200,
        translate("field_name_cannot_exceed_characters", {
          fieldName: translate("description"),
          number: 200,
        }),
      ),
    unitPrice: Yup.number()
      .required(translate("unitPrice_is_required"))
      .transform((value) => (Number.isNaN(value) ? null : value))
      .typeError(translate("unitPrice_is_required")),
    quantity: Yup.number()
      .required(translate("quantity_is_required"))
      .min(1, translate("quantity_cannot_be_less_than_1"))
      .transform((value) => (Number.isNaN(value) ? null : value))
      .typeError(translate("quantity_is_required")),
    vat: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .nullable(),
    dtoType: Yup.string()
      .oneOf(["amount", "percentage"])
      .default("amount")
      .nullable(),
    isDiscountVisible: Yup.boolean().default(false),
    dto: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .nullable()
      .when("isDiscountVisible", {
        is: true,
        then: (schema) =>
          schema
            .required(translate("discount_is_required"))
            .typeError(translate("discount_is_required")),
      })
      .when("dtoType", {
        is: "percentage",
        then: (schema) =>
          schema.max(100, translate("discount_cannot_exceed_100_percent")),
      }),
    deliveryNote: Yup.string().nullable(),
    poNumber: Yup.string().nullable(),
    taxType: Yup.string().nullable(),
    vatPercentage: Yup.number()
      .transform((value) => (Number.isNaN(value) ? null : value))
      .nullable()
      .optional(),
    taxId:
      requireTax && !isPOorDN
        ? Yup.string().nullable().required(translate("tax_is_required"))
        : Yup.string().nullable().optional(),
  });

  return { itemsSchema };
};
